export const ui = {
    testimonyVideo : {
        inputUpload: document.querySelector('.testimony_upload_movie') as HTMLInputElement,
        videoContainer: document.querySelector('.content__moviePreview') as HTMLDivElement,
        videoElement: document.querySelector('.movie-preview') as HTMLVideoElement,
        uploadContainer: document.querySelector('.upload-movie') as HTMLDivElement,
        removeVideo: document.querySelector('.delete-movie') as HTMLButtonElement
    }
}